import React from "react"
import { Skeleton } from "@material-ui/lab"
import { Grid } from "@material-ui/core"

import { Portlet } from "@/components"

const RoleListSkeleton = () => {
	const exampleArray = Array.from(Array(5).keys())

	return (
		<Grid
			container
			spacing={2}
		>
			{
				exampleArray.map((_, index) => (
					<Grid
						item
						xs={12}
						key={index}
					>
						<Portlet
							elevation={1}
						>
							<Grid
								container
								alignItems="center"
								spacing={2}
								justifyContent="space-between"
							>
								<Grid
									item
									xs={6}
								>
									<Grid
										container
										justifyContent="flex-start"
										alignItems="center"
										spacing={3}
									>
										<Grid item>
											<Skeleton variant="rect" width={32} height={32} />
										</Grid>
										<Grid item>
											<Skeleton variant="text" width={200} height={40} />
										</Grid>
									</Grid>
								</Grid>
								<Grid
									item
									xs={6}
								>
									<Grid
										container
										justifyContent={"flex-end"}
										spacing={2}
									>
										<Grid
											item
										>
											<Skeleton variant="rect" width={60} height={60} />
										</Grid>
										<Grid
											item
										>
											<Skeleton variant="rect" width={60} height={60} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Portlet>
					</Grid>
				))
			}
		</Grid>
	)
}

export default RoleListSkeleton
